import Layout from "components/Layout";
import { ILocationsLayout } from "./LocationsLayoutInterfaces";
import DowntimeAppDrawerItems from "pages/Corporate/components/DowntimeAppDrawerItems";
import { useStyles } from "./LocationsLayout.styles";
import DowntimeAppDrawerFooterItems from "pages/Corporate/components/DowntimeAppDrawerFooterItems";
import Module1Icon from "components/Module1Icon";

const LocationsLayout = ({ children, headerTitle }: ILocationsLayout) => {
    const classes = useStyles();
    return (
        <Layout
            appDrawerItems={<DowntimeAppDrawerItems />}
            appDrawerFooterItems={
                process.env.REACT_APP_SHOW_DOWNTIME_HELP?.toLocaleLowerCase() === "true" ? (
                    <DowntimeAppDrawerFooterItems />
                ) : null
            }
            toolbarLogo={
                <>
                    <Module1Icon />
                    <span className={classes.mainTitle}>{headerTitle}</span>
                </>
            }
        >
            {children}
        </Layout>
    );
};

export default LocationsLayout;
